export enum Experiment {
  RemoveUpdatingBoBController = 'specs.responsive-editor.NoMeasureInstall',
  UseAppDataForRoutes = 'specs.membersArea.UseAppDataForRoutes',
  DisableRouteIntegrityCheck = 'specs.membersArea.DisableRouteIntegrityCheck',
  SplitInstallation = 'specs.membersArea.SplitInstallation',
  InstalledWidgetsFromRoutes = 'specs.membersArea.installedWidgetsFromRoutes',
  AddWidgetsPluginsResilience = 'specs.membersArea.AddWidgetsPluginsResilience',
  VerticalDeletionRemoveRefreshApp = 'specs.profilePageBoB.VerticalDeletionRemoveRefreshApp',
  EnableSausageBar = 'specs.membersArea.EnableSausageBar',
  EnableMyAccountParallelInstall = 'specs.membersArea.EnableMyAccountParallelInstall',
  EnableUnifiedManager = 'specs.membersArea.EnableUnifiedManager',
  EnableUninstallMASubApps = 'specs.membersArea.UninstallMASubApps',
  EnableFFLightboxErrorState = 'specs.profilePageBoB.EnableFFLightboxErrorState',
  EnablePageLoadErrorState = 'specs.profilePageBoB.EnablePageLoadErrorState',
}
